import React from 'react';
import { Field } from 'hellospa/components/editor/types';
import { Rule, Trigger, Action, Updates, AllowedTriggerField } from './types';
import sortRules, { buildDepthMap, isSorted } from './sort-rules';
import validate from './validate';
import runRules, { buildUpdates } from './run-rules';

export { operatorsForFields } from './constants';
export { getFieldIdsFromRules, isAllowedFieldType } from './utils';
export { default as cleanupRules } from './cleanup-rules';

export {
  sortRules,
  isSorted,
  Rule,
  Trigger,
  Action,
  AllowedTriggerField,
  validate,
  buildDepthMap,
};

export default runRules;

export function useConditionalLogic(
  fields: Field[],
  rules: Rule[],
  updateFields: (updates: Updates) => void,
) {
  const sortedRules = React.useMemo(() => {
    if (!rules) {
      return [];
    }
    return sortRules(fields, rules);
  }, [fields, rules]);

  React.useMemo(() => {
    if (sortedRules.length === 0) {
      return;
    }

    const updates = buildUpdates(fields, sortedRules);
    if (Object.keys(updates).length > 0) {
      updateFields(updates);
    }
  }, [fields, sortedRules, updateFields]);
}
